import React, { FC } from 'react';
import { View, Text } from 'react-native';
import { UseTableColumnsParams } from '@v2/pages/common/components/NCFileBatchEvents/types';
import { font as initialFont } from '@styles/fonts';
import { EventStatusSubStatusExecModeProps } from '@v2/pages/common/components/NCFileBatchEvents/components/EventStatusSubStatusExecMode';

export interface QuantityDeltaCellProps extends Pick<UseTableColumnsParams, 'C' | 'font'>, Pick<EventStatusSubStatusExecModeProps, 'event'> {}
{
}

const QuantityDeltaCell: FC<QuantityDeltaCellProps> = ({ event, C, font = initialFont }) => {
  const quantityDelta = event?.quantityDelta;

  if (!quantityDelta) return null;

  const shouldDisplayPlus = quantityDelta > 0;

  return (
    <View>
      <Text style={[font['Subhead 2'], { color: C('Label/Light/Tertiary') }]}>
        {shouldDisplayPlus && '+'}
        {quantityDelta}
      </Text>
    </View>
  );
};

export default React.memo(QuantityDeltaCell, (prev, next) => {
  return prev.event.quantityDelta === next.event.quantityDelta && prev.C.scheme === next.C.scheme;
});
